import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {useNavigate } from 'react-router-dom'
import {
  Container,
  Spinner,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Alert,
  Row,
  Col,
  Table,
} from 'reactstrap';
import { getItemStorage } from '../../redux/actions/forms';
import Loading from '../../components/Loading/Loading';

function ItemStorage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const response = useSelector((state) => state.forms.getItemStorage);
  const [loading, setLoading] = useState(true);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [filterNI, setfilterNI] = useState('');
  const [filterMandante, setfilterMandante] = useState('');
  const [data, setData] = useState([]);

  useEffect(() => {
    document.title = 'BGL - BODEGAJE';
    window.scrollTo(0, 0);

    dispatch(getItemStorage());
  }, []);

  useEffect(() => {
    if (response) {
      if (response.status === 'success') {
        setLoading(false);
        setData(response.data);
      }
      setAlertTitle(response.status);
      setAlertType(response.status);
      setAlertMessage(response.message);
    }
  }, [response]);

  const onDismiss = () => setShowAlert(false);
  const goToItem = (item) => {
    navigate('/item-admin', { state: item });
  };

  return loading ? (
    <Loading />
  ) : (
    <Container className="container-border">
      <Container>
        <Alert color={alertType} isOpen={showAlert} toggle={onDismiss}>
          {alertTitle} - {alertMessage}
        </Alert>
      </Container>
      <h1>BODEGAJE</h1>
      <Container style={{ marginTop: 20, marginBottom: 20 }}>
        <h3>Filtros</h3>
        <Input
          className="col-md-8 mb-1"
          placeholder="Numero Interno"
          type="text"
          value={filterNI}
          onChange={(e) => {
            setfilterNI(e.target?.value);
          }}
        />
        <Input
          className="col-md-8"
          placeholder="Mandante"
          type="text"
          value={filterMandante}
          onChange={(e) => setfilterMandante(e.target?.value)}
        />
      </Container>
      <Container>
        <Table hover>
          <thead>
            <tr>
              <th>Número Interno</th>
              <th>Nombre</th>
              <th>Mandante</th>
              <th>Categoria</th>
              <th>Dias sin liberar</th>
              <th>Ver</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              return row.data.head.numerointerno?.value.includes(filterNI) &
                row.data.head.mandante?.value.includes(filterMandante) ? (
                <tr key={index}>
                  <td>{row.data.head.numerointerno?.value}</td>
                  <td>{` ${row.data.head.ano?.value} ${
                    row.data.head.marca?.value
                  } ${row.data.head.modelo?.value} ${
                    row.data.head.version?.value
                      ? ` ${row.data.head.version?.value}`
                      : ''
                  }`}</td>
                  <td>{row.data.head.mandante?.value}</td>
                  <td>{row.data.head.categoria?.value}</td>
                  <td>{row.days} dias</td>
                  <td>
                    {
                      <Button
                        onClick={() => {
                          goToItem(row.data);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </Button>
                    }
                  </td>
                </tr>
              ) : (
                <tr key={index}></tr>
              );
            })}
          </tbody>
        </Table>
      </Container>
    </Container>
  );
}
export default ItemStorage;
